// extracted by mini-css-extract-plugin
export var equalColumn = "_dc-0";